import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox } from '~components/forms/checkbox';
import { DAYS } from '~src/constants';

import withControlled from '~components/forms/form/with-controlled';

export const Availability = ({ onChange = () => { }, value = [], disabled, errors, ...rest }) => {
  const intl = useIntl();

  const handleChange = useCallback((day) => {
    if (value.indexOf(day) >= 0) {
      onChange(value.filter((d) => d !== day));
      return;
    }

    const newValue = [...value, day];
    onChange(newValue);
  });

  return (
    <div className="c-availability"  >
      <div className="c-checkbox__container--horizontal">
        {DAYS.map((day, index) => (
          <Checkbox
            key={day}
            checked={value.indexOf(day) >= 0}
            onChange={() => handleChange(day)}
            label={intl.formatMessage({ id: `days.long.${day}` })}
            className="l-bordered"
            {...rest}
          />
        ))}
        {errors && !disabled ? <div className="c-availability__error l-error">{errors.message}</div> : null}
      </div>
    </div>
  );
};

export const AvailabilityControlled = withControlled(Availability);
